var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"amount-badge"},[_c('span',{staticClass:"amount font-weight-bold",class:{'text-green': _vm.type == 'DEPOT', 'text-red': _vm.type == 'RETRAIT'}},[_vm._v(" "+_vm._s(_vm.formattedAmount)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }